/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./user-profile.m.css";
import { SvgHandler } from "../svg-handler/svg-handler";
import defaultAuthorIcon from "../../../assets/icons/user-icon.svg";
import { UserData } from "./user-profile-data";
import { getLoginLink } from "../pages/login/sso-utils";
import get from "lodash/get";
import { getCookie } from "../../utils";

export const UserProfile = ({ sso, member, customCssClasses = "", localizedSignIn, sketchesHost, whiteListedUrlParams, isMobileHeader = false }) => {
  useEffect(() => {
    global?.addEventListener("message", metypeEventHandler);
  }, []);

  const metypeEventHandler = (event) => {
    const action = get(event, ["data", "action"]);
    if (action === "metype_login") {
      getLoginLink(member, sso, sketchesHost, whiteListedUrlParams);
    }
  };

  const hasQtAuthCookie = typeof window !== 'undefined' && getCookie('qt-auth');
  const isSubscriber = typeof window !== 'undefined' && getCookie('is-subscriber') === 'true';

  if (hasQtAuthCookie && !member?.["verification-status"]) {
    // On mobile, never show Sign In button — only show Premium icon (handled by UserData)
    if (isMobileHeader) {
      if (isSubscriber) {
        return (
          <div styleName={`sign-btn ${customCssClasses}`}>
            <span styleName="white-space">
              <div className="profile-skeleton" style={{ width: "24px", height: "24px", borderRadius: "50%", backgroundColor: "#eee", display: "inline-block" }} />
            </span>
          </div>
        );
      }
      return null;
    }
    if (isSubscriber) {
      return (
        <div styleName={`sign-btn ${customCssClasses}`}>
          <span styleName="white-space">
            <div className="profile-skeleton" style={{ width: "24px", height: "24px", borderRadius: "50%", backgroundColor: "#eee", display: "inline-block" }} />
          </span>
        </div>
      );
    } else {
      return (
        <div
          onClick={() => getLoginLink(member, sso, sketchesHost, whiteListedUrlParams)}
          styleName={`sign-btn ${customCssClasses}`}
        >
          <span styleName="white-space" className="sign-in-btn">
            <div styleName="sign-in-svg" className="sign-in-svg">
              <SvgHandler xlinkHref={defaultAuthorIcon} clazzName='author-icon' width='24' height='24' viewBox='0 0 24 24' />
            </div>
            <div styleName="sign-in-btn" className="sign-in-button">
              {localizedSignIn || "Sign in"}
            </div>
          </span>
        </div>
      );
    }
  }

  if (!member?.["verification-status"]) {
    // On mobile, don't show Sign In button (scenario 1: mobile shows Subscribe only)
    if (isMobileHeader) return null;
    return (
      <div
        onClick={() => getLoginLink(member, sso, sketchesHost, whiteListedUrlParams)}
        styleName={`sign-btn ${customCssClasses}`}
        data-testid="sign-in-btn"
      >
        <span styleName="white-space" data-test-id="user-profile" className="sign-in-btn">
          <div styleName="sign-in-svg" className="sign-in-svg" data-testid="sign-in-svg">
            <SvgHandler
              xlinkHref={defaultAuthorIcon}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              svgWrapperClazzName="svg-wrapper"
            />
          </div>
          <div styleName="sign-in-btn" className="sign-in-button" data-testid="sign-in-button">
            {localizedSignIn || "Sign in"}
          </div>
        </span>
      </div>
    );
  } else {
    return <UserData customCssClasses={customCssClasses} isMobileHeader={isMobileHeader} />;
  }
};

UserProfile.propTypes = {
  member: PropTypes.object,
  logout: PropTypes.func,
  customCssClasses: PropTypes.string,
  localizedSignIn: PropTypes.string,
  sso: PropTypes.shape({
    enableSingleSignOn: PropTypes.bool,
    bridgeKeeperClientId: PropTypes.string,
  })
};
